import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Form } from 'antd'
import {
  useGetResultInfo,
  useGetAttackType,
  useGetAttck,
  useGetAPTList,
  useGetUseCaseList,
  useUpdateResourceInterceptStatus,
  useGetTagTreeOptions,
  useGetOfflineLogImportInfo,
  useGetResourceFilterData,
  useGetDeviceProtectionList,
  useGetAttackDefenseRanking,
  useGetRiskLevelDistribution,
  useGetResourceLevelsRanking,
  useGetTemplateLoseEfficacyRanking,
  useGetVerifyDistribution,
  useAddReport,
  useDeleteList,
  useGetResultPluginDetail,
  useDeleteOfflineLogImportInfo,
} from './utils'

export const useTaskDetailHooks = () => {
  const [form] = Form.useForm()
  const [searchParams] = useSearchParams()
  const resultId = searchParams.get('id') as string
  const taskId = searchParams.get('task_id') as string
  const [id, setId] = useState(resultId)

  // API hooks
  const [getTaskInfo, taskInfo] = useGetResultInfo()
  const [getAttackType, attackType] = useGetAttackType()
  const [getAttck, attckList] = useGetAttck()
  const [getAPTList, aptList] = useGetAPTList()
  const [getUseCaseList, loading] = useGetUseCaseList()
  const [updateResourceInterceptStatus, updateInterceptStatusLoading] =
    useUpdateResourceInterceptStatus()
  const [getTagTreeOptions, tagTreeOptions] = useGetTagTreeOptions()
  const [getOfflineLogInfo, importRecord] = useGetOfflineLogImportInfo()
  const [getResourceFilterData, resourceFilterData] = useGetResourceFilterData()
  const [getDeviceProtectionList, deviceProtectionList] = useGetDeviceProtectionList()
  const [getAttackDefenseRanking, attackDefenseRanking] = useGetAttackDefenseRanking()
  const [getRiskLevelDistribution, riskLevelDistribution] = useGetRiskLevelDistribution()
  const [getResourceLevelsRanking, resourceLevelsRanking] = useGetResourceLevelsRanking()
  const [getTemplateLoseEfficacyRanking, templateLoseEfficacyRanking] =
    useGetTemplateLoseEfficacyRanking()
  const [getVerifyDistribution, verifyDistribution] = useGetVerifyDistribution()
  const [generateReport, createLoading] = useAddReport()
  const [deleteTask] = useDeleteList()
  const [getResultPluginDetail, data, detailLoading] = useGetResultPluginDetail()
  const [deleteOfflineLogInfo, deleteRecordLoading] = useDeleteOfflineLogImportInfo()

  return {
    form,
    id,
    setId,
    taskId,
    getTaskInfo,
    taskInfo,
    getAttackType,
    attackType,
    getAttck,
    attckList,
    getAPTList,
    aptList,
    getUseCaseList,
    loading,
    updateResourceInterceptStatus,
    updateInterceptStatusLoading,
    getTagTreeOptions,
    tagTreeOptions,
    getOfflineLogInfo,
    importRecord,
    getResourceFilterData,
    resourceFilterData,
    getDeviceProtectionList,
    deviceProtectionList,
    getAttackDefenseRanking,
    attackDefenseRanking,
    getRiskLevelDistribution,
    riskLevelDistribution,
    getResourceLevelsRanking,
    resourceLevelsRanking,
    getTemplateLoseEfficacyRanking,
    templateLoseEfficacyRanking,
    getVerifyDistribution,
    verifyDistribution,
    generateReport,
    createLoading,
    deleteTask,
    getResultPluginDetail,
    data,
    detailLoading,
    deleteOfflineLogInfo,
    deleteRecordLoading,
  }
}

export const useTaskDetailState = () => {
  const [executeTimeId, setExecuteTimeId] = useState('')
  const [logInfo, setLogInfo] = useState<{ visible: boolean; content: string }>({
    visible: false,
    content: '',
  })
  const [failLogInfo, setFailLogInfo] = useState<{ visible: boolean; content: [] }>({
    visible: false,
    content: [],
  })
  const [filterParams, setFilterParams] = useState({
    page: 1,
    page_size: 20,
  })
  const [filterFormValue, setFilterFormValue] = useState<{
    field: string | number
    value: string | number | string[] | number[] | undefined
  }>({
    field: '',
    value: '',
  })
  const [useCaseList, setUseCaseList] = useState<any[]>([])
  const [useCaseTotal, setUseCaseTotal] = useState(0)
  const [fixPayloadCount, setFixPayloadCount] = useState(0)
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([])
  const [random, setRandom] = useState(0)
  const [cardActive, setCardActive] = useState('')
  const [importVisible, setImportVisible] = useState(false)
  const [reportVisible, setReportVisible] = useState({
    visible: false,
    result_id: '',
    name: '',
  })
  const [active, setActive] = useState<string>()
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [detailDrawerVisible, setDetailDrawerVisible] = useState(false)
  const [pluginDetail, setPluginDetail] = useState<any>()
  const [fixedModalVisible, setFixedModalVisible] = useState(false)
  const [riskLevelSelectOpen, setRiskLevelSelectOpen] = useState(false)
  const [attackTypeSelectOpen, setAttackTypeSelectOpen] = useState(false)
  const [resourceLevelSelectOpen, setResourceLevelSelectOpen] = useState(false)
  const [interceptStatusSelectOpen, setInterceptStatusSelectOpen] = useState(false)
  const [deviceStatusSelectOpen, setDeviceStatusSelectOpen] = useState(false)
  const [infoActiveTab, setInfoActiveTab] = useState('taskTemplate')
  const [activeTab, setActiveTab] = useState('failed')
  const [recordVisible, setRecordVisible] = useState(false)

  return {
    executeTimeId,
    setExecuteTimeId,
    logInfo,
    setLogInfo,
    failLogInfo,
    setFailLogInfo,
    filterParams,
    setFilterParams,
    filterFormValue,
    setFilterFormValue,
    useCaseList,
    setUseCaseList,
    useCaseTotal,
    setUseCaseTotal,
    fixPayloadCount,
    setFixPayloadCount,
    selectedRowKeys,
    setSelectedRowKeys,
    random,
    setRandom,
    cardActive,
    setCardActive,
    importVisible,
    setImportVisible,
    reportVisible,
    recordVisible,
    setRecordVisible,
    setReportVisible,
    active,
    setActive,
    deleteVisible,
    setDeleteVisible,
    detailDrawerVisible,
    setDetailDrawerVisible,
    pluginDetail,
    setPluginDetail,
    fixedModalVisible,
    setFixedModalVisible,
    riskLevelSelectOpen,
    setRiskLevelSelectOpen,
    attackTypeSelectOpen,
    setAttackTypeSelectOpen,
    resourceLevelSelectOpen,
    setResourceLevelSelectOpen,
    interceptStatusSelectOpen,
    setInterceptStatusSelectOpen,
    deviceStatusSelectOpen,
    setDeviceStatusSelectOpen,
    infoActiveTab,
    setInfoActiveTab,
    activeTab,
    setActiveTab,
  }
}
